import { render, staticRenderFns } from "./AnimationIcon.vue?vue&type=template&id=19797da6&scoped=true"
import script from "./AnimationIcon.vue?vue&type=script&lang=js"
export * from "./AnimationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19797da6",
  null
  
)

export default component.exports